module.exports = __webpack_public_path__ + "acd312b483dda9cba360af08ac1bcac3.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/owls/new_owl_3.png
// module id = 1771
// module chunks = 0